import { createStore } from 'vuex';
import carouselModule, { CAROUSEL_STORE_NAMESPACE } from './carousel/carousel.module';
import infographicModule, { INFOGRAPHIC_STORE_NAMESPACE } from './infographic/infographic.module';
import announcementModule, { ANNOUNCEMENT_STORE_NAMESPACE } from './announcement/announcement.module';
import videoModule, { VIDEO_STORE_NAMESPACE } from './video/video.module';
import documentModule, { DOCUMENT_STORE_NAMESPACE } from './document/document.module';
import committeeModule, { COMMITTEE_STORE_NAMESPACE } from './committee/committee.module';
import informationModule, { INFORMATION_STORE_NAMESPACE } from './information/information.module';
import fiscalYearModule, { FISCALYEAR_STORE_NAMESPACE } from './fiscalYear/fiscalYear.module';
import fiscalYearCabinetModule, { FISCALYEAR_CABINET_STORE_NAMESPACE } from './fiscalYearCabinet/fiscalYearCabinet.module';
import fiscalYearMinisterModule, { FISCALYEAR_MINISTER_STORE_NAMESPACE } from './fiscalYearMinister/fiscalYearMinister.module';
import fiscalYearRegionModule, { FISCALYEAR_REGION_STORE_NAMESPACE } from './fiscalYearRegion/fiscalYearRegion.module';
import projectModule, { PROJECT_STORE_NAMESPACE } from './project/project.module';
import pscModule, { PSC_STORE_NAMESPACE } from './psc/psc.module';
import provinceModule, { PROVINCE_STORE_NAMESPACE } from './province/province.module';
import emergencyModule, { EMERGENCY_STORE_NAMESPACE } from './emergency/emergency.module';
import emergencyTypeModule, { EMERGENCY_TYPE_STORE_NAMESPACE } from './emergencyType/emergencyType.module';
import taskModule, { TASK_STORE_NAMESPACE } from './task/task.module';
import taskTypeModule, { TASK_TYPE_STORE_NAMESPACE } from './taskType/taskType.module';
import consentModule, { CONSENT_STORE_NAMESPACE } from './consent/consent.module';
import supportModule, { SUPPORT_STORE_NAMESPACE } from './support/support.module';
import lawModule, { LAW_STORE_NAMESPACE } from './law/law.module';
import downloadModule, { DOWNLOAD_STORE_NAMESPACE } from './download/download.module';

export default createStore({
  modules: {
    [CAROUSEL_STORE_NAMESPACE]: carouselModule,
    [ANNOUNCEMENT_STORE_NAMESPACE]: announcementModule,
    [INFOGRAPHIC_STORE_NAMESPACE]: infographicModule,
    [VIDEO_STORE_NAMESPACE]: videoModule,
    [DOCUMENT_STORE_NAMESPACE]: documentModule,
    [COMMITTEE_STORE_NAMESPACE]: committeeModule,
    [INFORMATION_STORE_NAMESPACE]: informationModule,
    [FISCALYEAR_STORE_NAMESPACE]: fiscalYearModule,
    [FISCALYEAR_CABINET_STORE_NAMESPACE]: fiscalYearCabinetModule,
    [FISCALYEAR_MINISTER_STORE_NAMESPACE]: fiscalYearMinisterModule,
    [FISCALYEAR_REGION_STORE_NAMESPACE]: fiscalYearRegionModule,
    [PROJECT_STORE_NAMESPACE]: projectModule,
    [PSC_STORE_NAMESPACE]: pscModule,
    [PROVINCE_STORE_NAMESPACE]: provinceModule,
    [EMERGENCY_STORE_NAMESPACE]: emergencyModule,
    [EMERGENCY_TYPE_STORE_NAMESPACE]: emergencyTypeModule,
    [TASK_STORE_NAMESPACE]: taskModule,
    [TASK_TYPE_STORE_NAMESPACE]: taskTypeModule,
    [CONSENT_STORE_NAMESPACE]: consentModule,
    [SUPPORT_STORE_NAMESPACE]: supportModule,
    [LAW_STORE_NAMESPACE]: lawModule,
    [DOWNLOAD_STORE_NAMESPACE]: downloadModule,
  }
});

export interface RootState {
  root: boolean;
  version: string;
}
